<template src="./html/Create.html"></template>

<script>
	import Dropzone from 'vue2-dropzone'
	import swal from 'sweetalert2'

	export default {
		props: ['user', 'isAuth', 'dropzone'],
		components: {
			'dropzone': Dropzone
		},
		data () {
			return {
				modal: {
					selector: 'media-create-' + new Date().getTime()
				},

				headers: null,
				media: null,
			}
		},
		watch: {
			'dropzone.url'() {
				this.$refs.dropzone.setOption('url', this.dropzone.url + '/media')
			},
		},
		mounted() {
			var that = this
			var modal = $('#'+this.modal.selector)
			modal.on("hidden.bs.modal", function() {
				that.$refs.dropzone.removeAllFiles()
			})
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.generateHeaders()
			},
			generateHeaders() {
				var token = this.$auth.getToken()
				var headers = {
					account: this.$platform.slug,
					Authorization: "Bearer " + token
				}
				this.headers = headers
			},
			open() {
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			dropzoneSuccess (response, file) {
				this.$emit('reload', file)
			},
			dropzoneRemoveFile (file, response) {
			},
			dropzoneError (file, message, xhr) {
				console.log(file)
				console.log(message)
				console.log(xhr)
				swal({
					title: xhr.statusText,
					text: xhr.responseText,
					type: "warning"
				});
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/MediaManager/views/Create.vue